import React, { useContext, useState } from 'react';
import { InputField, RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import {
  formatSsnForDisplay,
  handleInputFormat
} from '../../flows/shared/utils';
import { invalidCitizenshipValue, mapCitizenshipToSsnLabel } from './util';
import {
  restrictedFirstNameValidation,
  restrictedMiddleNameValidation,
  restrictedLastNameValidation
} from '../../flows/shared/validations';
import styles from './style.css';
import { withDefault } from '../../core/util';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const MinorPISection = () => {
  const {
    appState: {
      store: { additionalCustomers = [] }
    },
    formProps
  } = useContext(FlowContext);

  const {
    minorFirstName = '',
    minorMiddleName,
    minorLastName = '',
    minorDob = '',
    minorCitizenship = '',
    minorSsn = ''
  } =
    additionalCustomers.map(person => ({
      minorFirstName: person.name.firstName,
      minorMiddleName: person.name.middleName,
      minorLastName: person.name.lastName,
      minorDob: person.dob,
      minorCitizenship: person.citizenship,
      minorSsn: person.taxID
    }))[0] || {};

  const [ssnLabel, setSsnLabel] = useState(
    mapCitizenshipToSsnLabel(minorCitizenship)
  );
  const [dobValue, setDobValue] = useState('');
  const [ssnValue, setSSNValue] = useState('');

  const handleCitizenshipBtnClick = ({ target: { value } }) =>
    setSsnLabel(mapCitizenshipToSsnLabel(value));

  return (
    <div className="sections" data-name="minorPISection">
      Minor
      <hr />
      <div className="section">
        <div className="name-fields">
          <div className="first-name">
            <InputField
              type="text"
              title="First Name"
              {...formProps.minorFirstName}
              defaultValue={minorFirstName}
              validation={restrictedFirstNameValidation}
              className="blocked_data"
              data-name={generateGeneralTestID('MinorPI', 'FirstName')}
            />
          </div>

          <div className="middle-name">
            <InputField
              type="text"
              title="Middle Name"
              {...formProps.minorMiddleName}
              defaultValue={minorMiddleName}
              validation={restrictedMiddleNameValidation}
              className="blocked_data"
              data-name={generateGeneralTestID('MinorPI', 'MiddleName')}
            />
          </div>
          <div className="last-name">
            <InputField
              type="text"
              title="Last Name"
              {...formProps.minorLastName}
              defaultValue={minorLastName}
              validation={restrictedLastNameValidation}
              className="blocked_data"
              data-name={generateGeneralTestID('MinorPI', 'LastName')}
            />
          </div>
        </div>
        <div className="personal-info-fields">
          <div className="dob-input">
            <InputField
              style={{ paddingRight: '8px' }}
              type="text"
              title="Date of Birth"
              aria-describedby="hint"
              {...formProps.minorDob}
              value={withDefault(dobValue, minorDob)}
              maxLength="10"
              onChange={evt => handleInputFormat(evt, 'DATE', setDobValue)}
              placeholder="mm/dd/yyyy"
              className="blocked_data"
              data-name={generateGeneralTestID('MinorPI', 'BirthDate')}
            />
            <dd id="hint" style={{ display: 'none' }}>
              This is a required field. Please enter a two digit month, a two
              digit day and a four digit year for the Date of Birth value.
            </dd>
          </div>
          <div className="ssn-input">
            <InputField
              title={ssnLabel}
              placeholder="000-00-0000"
              maxLength="11"
              onChange={evt => handleInputFormat(evt, 'SSN', setSSNValue)}
              {...formProps.minorSsn}
              value={withDefault(ssnValue, formatSsnForDisplay(minorSsn))}
              className="blocked_data"
              data-name={generateGeneralTestID('MinorPI', 'TaxID')}
            />
          </div>
          <div className="citizenship-input joint-owner">
            <RadioGroupField
              title="Citizenship"
              name="minor-citizenship"
              onChange={handleCitizenshipBtnClick}
              {...formProps.minorCitizenship}
              options={[
                {
                  title: 'U.S. Citizen',
                  value: 'US_CITIZEN',
                  defaultChecked:
                    minorCitizenship === 'US_CITIZEN' ||
                    invalidCitizenshipValue(minorCitizenship)
                },
                {
                  title: 'U.S. Resident Alien',
                  value: 'RESIDENT_ALIEN',
                  defaultChecked: minorCitizenship === 'RESIDENT_ALIEN'
                }
              ]}
            />
          </div>
        </div>
        <style jsx>{styles}</style>
      </div>
    </div>
  );
};

export default MinorPISection;
